import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetListLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_LOTTERY
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetListLotteryAction({
                    data: data.data,
                    page: data.countPage,
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetListLottery as SetGetListLottery
}